import {whatsNewHref} from 'src/components/App/Header/HeaderTrayHelp/HeaderTrayHelp.consts'

export const TRY_PIPELINES_LINK =
  'https://lp.jetbrains.com/teamcity-pipelines-in-enterprise-eap-4708/'

/**
 * The title is intentionally different from the standard "Welcome to TeamCity 2026.2"
 */
export const TITLE = 'Pipelines, now for everyone'

export const TEXT = `
Pipelines are now generally available in TeamCity Cloud and TeamCity On-Premises.

Designed to fit into your existing TeamCity setup, Pipelines support:

- **Job debugging** to investigate issues directly in the build environment
- **Kotlin DSL** for managing pipeline configuration as code
- **Build chain integration** for adopting Pipelines without rebuilding your workflows
`.trim()

export const CALL_TO_ACTION_LINK = whatsNewHref

export const CALL_TO_ACTION_LABEL = 'Learn more'
